<template>
  <div class="inscription-flow-info container">
    <h2 class="form-title">{{ $texts.titleFormRegister }}</h2>
    <div v-html="$appSettings.InfoNotice"></div>
    <footer>
      <a class="btn" :href="$appSettings.CancelUrl">{{
        $texts.cancelButton
      }}</a>
      <router-link class="btn secondary-color" :to="route">{{
        $texts.nextButton
      }}</router-link>
    </footer>
    <footer-panel-vuetify
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel-vuetify>
  </div>
</template>

<script>
// import Loader from './components/Loader.vue'
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { AccountDetectionModeModule } from "@/InscriptionFlowsAdmin/store/modules/AccountDetectionModeModule";
import { AccountDetectionModes } from "@/InscriptionFlow/models/enums/AccountDetectionModes";

export default Vue.extend({
  name: "inscription-flow-info",

  components: { FooterPanelVuetify },

  data() {
    return {
      linking: false,
      accountDetectionModes: getModule(AccountDetectionModeModule)
    };
  },

  computed: {
    route() {
      if (this.$appSettings.DuplicatedEmails) {
        return {
          name: "inscription-flow-register"
        };
      } else {
        if (
          this.accountDetectionModes.flowADM === AccountDetectionModes.Email
        ) {
          return {
            name: "form-account-detection-by-email",
            params: {
              linking: this.linking
            }
          };
        } else {
          return {
            name: "form-account-detection-by-national-id",
            params: {
              linking: this.linking
            }
          };
        }
      }
    }
  },
  methods: {},

  watch: {}
});
</script>

<style scoped>
footer {
  display: flex;
  margin: 10px;
  justify-content: space-evenly;
}
</style>
